export default "__VITE_ASSET__C5J6zfmk__"